<template>
  <div class="rbu-card mt-4">
    <div class="rbu-card-header">
      <h3 class="px-4 mr-4 d-flex align-center">Section Fluctuation Summary</h3>
    </div>
    <div class="rbu-card-content">
      <v-simple-table>
        <template v-slot:default>
          <RbuSectionFluctuationTableHeader></RbuSectionFluctuationTableHeader>
          <tbody>
            <tr
              v-for="(module, moduleIdx) in fluctuationModules_not_ignored"
              :key="moduleIdx"
            >
              <td>
                <div v-if="moduleIdx === 0">Base Value</div>
              </td>
              <td>{{ module.name }}</td>
              <td>{{ parseFloat(module.sub_total).toFixed(15) }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            <RbuAdjustment
              :value="section"
              @update="onUpdate"
              :override_digit="true"
              :override_digit_number="15"
            ></RbuAdjustment>

            <tr>
              <td></td>
              <td class="text-right">Adjusted trade %</td>
              <td>
                <span class="font-weight-bold">
                  {{ adjustedTradePercentage }} %</span
                >
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>
<script>
import RbuSectionFluctuationTableHeader from "@/components/rbu/RbuSectionFluctuationTableHeader.vue";
import RbuAdjustment from "@/components/rbu/RbuAdjustment.vue";
import { computed, watch } from "@vue/composition-api";
import floatingPointFix from "js-floating-point";

export default {
  name: "RbuSectionFluctuationContractPercentage",
  components: { RbuAdjustment, RbuSectionFluctuationTableHeader },
  props: {
    section: Object,
    fluctuationModules: Array,
  },
  setup(props, { root, emit }) {
    const fluctuationModules_not_ignored = computed(() => {
      return props.fluctuationModules.filter((f) => !f.ignored);
    });
    const onUpdate = function (evt) {
      console.debug("Contract Percentage Update: ", evt);

      let updates = {
        ...evt,
      };

      emit("update", updates);
    };

    const adjustedTradePercentage = computed(() => {
      let p = 0;

      props.fluctuationModules.forEach((m) => {
        if (!m.ignored) {
          p = floatingPointFix(p + parseFloat(m.sub_total));
        }
      });

      // if (props.section.edition.contract_percentage) {
      //   p += parseFloat(props.section.edition.contract_percentage) / 100;
      // }

      // p *= 100;

      function applyValueAdjustment() {
        if (
          props.section.adjustment_value &&
          parseFloat(props.section.adjustment_value)
        ) {
          p = floatingPointFix(p + parseFloat(props.section.adjustment_value));
        }
      }

      function applyPercentageAdjustment() {
        if (
          props.section.adjustment_percentage &&
          parseFloat(props.section.adjustment_percentage)
        ) {
          p = floatingPointFix(
            (p * parseFloat(props.section.adjustment_percentage)) / 100
          );
        }
      }

      if (props.section.adjustment_value_first) {
        applyValueAdjustment();
        applyPercentageAdjustment();
      } else {
        applyPercentageAdjustment();
        applyValueAdjustment();
      }

      p = Math.round(floatingPointFix(p * 100)) / 100;
      return p;
    });

    watch(
      () => adjustedTradePercentage.value,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          emit("update", { fluctuation_value: newValue });
        }
      },
      { immediate: true }
    );

    return {
      onUpdate,
      adjustedTradePercentage,
      fluctuationModules_not_ignored,
    };
  },
};
</script>
